import { useTranslation } from "react-i18next";

const Footer = () => {
    const {t} = useTranslation()
    return (
        <div 
            style={{
                maxWidth: "1280px",
                borderRadius: "10px",
                margin: "10px auto",
            }}  
            className="w-full px-3 xs:px-6 py-4 pb-5 my-3 shadow-2xl rounded-xl text-left">
            <ul className="text-3xs sm:text-xs md:text-sm">
                <li>®Pony Express Turkiye. All rights reserved.</li>
                <li>
                    {t("footer.info")}
                </li>
            </ul>
        </div>
    );
};

export default Footer;
